import { redirect } from '@tanstack/react-router'

import { isSuccess } from '@orus.eu/result'

import type { RouterContext } from '#/shared/routing/router-context.ts'

/** The unpaid-invoice recovery flow is not offered in NL: those users are sent to their payment methods instead. */
export async function redirectNlUsersToPaymentMethods(context: RouterContext): Promise<void> {
  const sessionResult = await context.session.getSessionResult()

  if (!isSuccess(sessionResult) || !sessionResult.output.user) return

  const operatingZone = await context.queryClient.ensureQueryData(
    context.trpc.subscriptions.getMyDefaultOperatingZone.queryOptions(),
  )

  if (operatingZone === 'nl') {
    throw redirect({ to: '/payment-methods', replace: true })
  }
}
